import { List } from 'immutable';
import { getDataType } from '../report/configReportGetters';
// @ts-expect-error untyped module
import { isSupportedCrmObject } from '../crmObjects/utils';
import { dataTypeSettings } from '../retrieve/inboundDb/common/dataTypes';
export function getIdProperties(report) {
  const dataType = getDataType(report);
  if (!isSupportedCrmObject(dataType)) {
    const {
      idColumn,
      hideIdColumn
    } = dataTypeSettings[dataType] || {};
    if (idColumn && !hideIdColumn) {
      return List([idColumn]);
    }
  }
  return List();
}